import React, { useCallback, useState, useRef, useEffect } from 'react'
import { useDeviceScopedInit } from 'src/hooks/useDeviceScopedInit'
import { useTranslation } from 'src/utils/i18n'

import styles from '../../../styles/contacts.module.scss'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

import TemporaryDrawer from 'src/@core/components/contacts-info'
import toExcel from 'src/@core/components/to-excel'
import { getContact } from '/src/@api/dashboard'

import IosVerfiyProcess from 'src/@core/components/ios-verfiy-process'
import Image from 'next/image'
import { setCurrentTab } from 'src/store/apps/Common'
import { useDispatch } from 'react-redux'
import { pinyin } from 'pinyin-pro'
import ContentLoading from 'src/components/ContentLoading'

const Contacts = () => {
  const getFirstLetter = name => {
    if (!name) return '#'

    const py = pinyin(name, {
      toneType: 'none',
      nonZh: 'remove'
    })

    const firstLetter = py.charAt(0)

    // 英文
    if (/[a-zA-Z]/.test(firstLetter)) {
      return firstLetter.toUpperCase()
    }

    // 其他字符
    return '#'
  }
  const { t } = useTranslation('common')

  const childRef = useRef()

  const [initContacts, setInitContacts] = useState([])

  // 联系人信息
  const [userInfo, setUserInfo] = useState({ firstName: '' })

  // 联系人数组
  const [useContactsPeople, setContactsPeople] = useState([])
  const [isLoading, setIsLoading] = useState(true) //正在加载获取数据

  // 分页参数
  const [pagination, setPagination] = useState({
    reqNum: 50, // 单次查询数量
    nowOffset: 0, // 偏移量
    maxNum: false // 全部数据查询完毕
  })

  const refs = useRef([])

  const addToRefs = el => {
    if (el && !refs.current.includes(el)) {
      refs.current.push(el)
      console.log(el.innerText, el.textContent, el.offsetTop)
    }
  }

  const classifyContacts = contacts => {
    const map = {}

    // 初始化 A-Z + #
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ#'.split('').forEach(k => {
      map[k] = []
    })

    contacts.forEach(item => {
      const fullName = `${item.firstName || ''}${item.lastName || ''}`.trim()
      const key = getFirstLetter(fullName)

      map[key].push(item)
    })

    // 每个分组内部排序（英文 & 中文拼音）
    Object.keys(map).forEach(key => {
      map[key].sort((a, b) => {
        const nameA = `${a.firstName || ''}${a.lastName || ''}`
        const nameB = `${b.firstName || ''}${b.lastName || ''}`

        const pyA = pinyin(nameA, { toneType: 'none' })
        const pyB = pinyin(nameB, { toneType: 'none' })

        return pyA.localeCompare(pyB)
      })
    })

    return Object.keys(map).map(key => ({
      type: key,
      arr: map[key]
    }))
  }

  // 获取联系人
  const getContactData = async nowOffset => {
    const res = await getContact({
      username:
        JSON.parse(localStorage.getItem('DeviceUser')) != null
          ? JSON.parse(localStorage.getItem('DeviceUser')).username
          : '',
      params: {
        category: 'CONTACT',
        offset: nowOffset,
        limit: pagination.reqNum
      }
    })

    const list = res?.data?.contents

    if (!list || list.length === 0) {
      setPagination(page => ({ ...page, maxNum: true }))
      setIsLoading(false)

      
return
    }

    const grouped = classifyContacts(list)

    if (nowOffset === 0) {
      // 第一页
      setInitContacts(grouped)
      setContactsPeople(grouped)
    } else {
      // 后续分页
      const merged = initContacts.map(item => {
        const current = grouped.find(g => g.type === item.type)

        const combined = [...item.arr, ...(current?.arr || [])]

        combined.sort((a, b) => {
          const nameA = `${a.firstName || ''}${a.lastName || ''}`
          const nameB = `${b.firstName || ''}${b.lastName || ''}`

          const pyA = pinyin(nameA, { toneType: 'none' })
          const pyB = pinyin(nameB, { toneType: 'none' })

          return pyA.localeCompare(pyB)
        })

        return {
          type: item.type,
          arr: combined
        }
      })

      setInitContacts(merged)
      setContactsPeople(merged)
    }
    setIsLoading(false)
  }

  // 设备切换时重置列表并重新拉数
  useDeviceScopedInit(
    useCallback(() => {
      setInitContacts([])
      setContactsPeople([])
      setPagination({ reqNum: 50, nowOffset: 0, maxNum: false })
      setIsLoading(true)
      getContactData(0)
    }, [])
  )

  let getContactsInfo = info => {
    // 当前点击联系人信息
    setUserInfo(info)

    // 打开抽屉
    childRef.current.toggleDrawerParent('right', true)
  }

  // 处理搜索联系人人
  const handleFilter = e => {
    let value = e.target.value

    if (value === '') {
      setContactsPeople(initContacts)

      return
    }

    // 搜索过滤
    let filterData = initContacts.map(item => {
      return {
        type: item.type,
        arr: item.arr.filter(children => {
          return (children.firstName + children.lastName).toUpperCase().indexOf(value.toUpperCase()) !== -1
        })
      }
    })
    setContactsPeople(filterData)
  }

  // 导出
  function formatJson(filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => v[j]))
  }

  // 处理导出数据

  const toexcel = () => {
    const th = ['name', 'Number', 'Email']
    const filterVal = ['name', 'number', 'email']

    let dataSource = []

    for (let i = 0; i < initContacts.length; i++) {
      if (initContacts[i].arr.length > 0) {
        let data = initContacts[i].arr.map(item => {
          try {
            return {
              name: item.firstName,
              number: item.phones instanceof Array ? item.phones[0].field : '',
              email: item.emailAddresses instanceof Array ? item.emailAddresses[0].field : ''
            }
          } catch (error) {
            return {
              name: '',
              number: '',
              email: ''
            }
          }
        })

        dataSource = dataSource.concat(data)
      }
    }
    var data = formatJson(filterVal, dataSource)

    toExcel({ th, data, fileName: 'export_contacts_data', fileType: 'xlsx', sheetName: 'sheet' })
  }

  const dom = useRef()

  const jump = val => {
    for (const item of refs.current) {
      if (item.textContent === val) {
        dom.current.scrollTop = item.offsetTop
        console.log(item.offsetTop)
      }
    }
  }

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 获取滚动百分比
  useEffect(() => {
    const handScroll = () => {
      if (dom.current) {
        const { scrollTop, scrollHeight, clientHeight } = dom.current
        const progress = scrollTop / (scrollHeight - clientHeight) * 100

        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = dom.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handScroll)
      }
    }
  }, [])

  // 监听滚动百分比
  useEffect(() => {
    if (scroll >= 100) {
      const nowOffset = pagination.nowOffset + pagination.reqNum
      setPagination(page => ({ ...page, nowOffset }))

      if (!pagination.maxNum) getContactData(nowOffset)
    }
  }, [scroll])

  const dispatch = useDispatch()

  useEffect(() => {
    const title = t('Contact')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  return (
    <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[20px] pb-[20px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex flex-col relative'>
      <div className='w-full text-right mb-[15px] px-[15px]'>
        <span
          className='text-[14px] text-[#007AFF] cursor-pointer'
          onClick={() => {
            toexcel()
          }}
        >
          {t('export_contacts')}
        </span>
      </div>
      <div className='w-full px-[15px]'>
        <TextField
          fullWidth
          className='h-[40px] bg-[rgba(235,235,239,0.92)] rounded-lg !border-0 text-[16px]'
          size='small'
          onInput={e => {
            handleFilter(e)
          }}
          placeholder={t('Search Contacts')}
          sx={{
            '& .MuiInputBase-root .MuiOutlinedInput-notchedOutline': { border: 0 },
            '& input::placeholder': { fontSize: '16px', color: '#818187', opacity: 100 }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                {/* <Icon icon='mdi:magnify' fontSize='1.25rem' /> */}
                <Image src='/images/contacts/search.svg' width={18} height={18} alt='search'></Image>
              </InputAdornment>
            )
          }}
        />
      </div>
      <div ref={dom} className='w-full flex flex-1 overflow-auto relative'>
        <div className='flex-1 px-[15px]'>
          {useContactsPeople.map(item => (
            <div key={item.type}>
              {item.arr.length > 0 ? (
                <dl className=''>
                  <dt
                    className='text-[15px] text-[#8A8A8D] font-[600] border-b border-[#E5E7EB] pt-[25px] pb-[5px]'
                    ref={addToRefs}
                  >
                    {item.type}
                  </dt>
                  <div className=''>
                    {item.arr &&
                      item.arr.map((children, i) => (
                        <dd
                          key={children.firstName + i}
                          className='py-[12px] border-b border-[#E5E7EB] text-[14px] font-[600] text-[#000000]'
                          onClick={() => {
                            getContactsInfo(children)
                          }}
                        >
                          <div className=''>
                            <span className=''>
                              {children.firstName}
                              {children.lastName}
                            </span>
                          </div>
                        </dd>
                      ))}
                  </div>
                </dl>
              ) : null}
            </div>
          ))}
        </div>
      </div>
      {/* 右侧字母 */}
      <div className='w-[15px] flex flex-col items-center justify-center absolute right-0 top-0 h-full pt-[99px]'>
        {[
          'A',
          'B',
          'C',
          'D',
          'E',
          'F',
          'G',
          'H',
          'I',
          'J',
          'K',
          'L',
          'M',
          'N',
          'O',
          'P',
          'Q',
          'R',
          'S',
          'T',
          'U',
          'V',
          'W',
          'X',
          'Y',
          'Z',
          '#'
        ].map((item, i) => (
          <div key={i} className='text-[10px] text-[#007AFF] font-[600] cursor-pointer' onClick={() => jump(item)}>
            {item}
          </div>
        ))}
      </div>
      <TemporaryDrawer data={userInfo} ref={childRef} />

      {isLoading ? (
        <div className='absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]'>
          <ContentLoading />
        </div>
      ) : null}

      {(initContacts.length > 0 || isLoading) ||
        <div className='text-center px-5 absolute inset-0 flex justify-center items-center pointer-events-none'>
          {t('It appears theres no data to show here yet')}<br />
          {t('If data exists it may take up to 1 hour to download and appear')}<br />
          {t('We suggest checking back in a little while')}
        </div>}
    </div>
  )
}

export default Contacts
